import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './MentorValidationPointsSubTab.css';

const API_URL = process.env.REACT_APP_API_URL || '';

function MentorValidationPointsSubTab() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchData = async () => {
    try {
      setLoading(true);
      const res = await axios.get(`${API_URL}/api/mentor-validation-points`);
      setItems(res.data);
      setError(null);
    } catch (err) {
      setError('Ошибка загрузки: ' + (err.response?.data?.detail || err.message));
      setItems([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  if (loading) {
    return <div className="mentor-points-loading">Загрузка...</div>;
  }

  return (
    <div className="mentor-validation-points-sub-tab">
      <div className="mentor-points-header">
        <h2>Очки валидации менторов</h2>
        <button type="button" className="btn btn-secondary" onClick={fetchData}>
          Обновить
        </button>
      </div>
      <p className="mentor-points-description">
        Баланс очков за применённые изменения (только просмотр, редактирование и добавление записей недоступны).
      </p>
      {error && <div className="mentor-points-error">{error}</div>}
      {items.length === 0 && !error ? (
        <div className="mentor-points-empty">Нет записей. Очки появятся после начисления при применении diff.</div>
      ) : (
        <div className="mentor-points-table-wrap">
          <table className="mentor-points-table">
            <thead>
              <tr>
                <th>ID</th>
                <th>ID ментора</th>
                <th>Логин</th>
                <th>Очки</th>
              </tr>
            </thead>
            <tbody>
              {items.map((row) => (
                <tr key={row.id}>
                  <td>{row.id}</td>
                  <td>{row.mentor_id}</td>
                  <td>{row.mentor_login ?? '—'}</td>
                  <td>{row.points}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default MentorValidationPointsSubTab;
